/* eslint-disable no-param-reassign */
import store from 'store'
// ToDo remove all API call functions outside of this helper and set a new helper
// we need to make sure this happens so we don't have depth linting
import { GetUserLocation } from 'data/common/Auth/actions'
import { getMyUser } from 'data/common/Auth/thunks'
import { getUpshifterRecommendedShifts } from 'data/upshifter/RecommendedShifts/thunks'
import { getUpshifterShifts } from 'data/upshifter/Shifts/thunks'
import { getUnreadNotifications } from 'data/upshifter/UnreadNotifications/thunks'
import { URLManager } from './URLManager'
import AuthService from './authService'
import history from './history'

// TTL
export const LOCATION_CHECK_TTL = 5
// 48 hours
export const NOTIFICATION_CHECK_TTL = 1

/**
 * Retry loading on chunk
 */

export const retry = (func, retriesLeft = 5, interval = 1000) =>
  new Promise((resolve, reject) => {
    func()
      .then(resolve)
      .catch(error => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error)
            return
          }
          retry(func, retriesLeft - 1, interval).then(resolve, reject)
        }, interval)
      })
  })

export const getShiftAllowedParams = () => {
  const params = [
    'search',
    'page',
    'sort_by',
    'date_start',
    'date_end',
    'to_hire',
    'type',
    'auto_accept',
    'favorite',
    'price_end',
    'price_start',
    'lng',
    'lat',
    'distance',
    'distance_in',
    'progress',
    'filled',
    'progress',
    'status',
    'property_id',
    'training_mode',
    'regions[]',
    'gig_types[]',
    'properties[]',
    'account_manager_id',
    'business_ids[]',
    'follow_by_user_ids[]',
    'industry_ids[]',
  ]
  return params
}

/**
 *
 * @param {*} urlSearchParams
 */
export const getShiftsURLParams = urlSearchParams => {
  const params = new URLSearchParams(urlSearchParams)
  const urlAllowedParams = getShiftAllowedParams()
  // const params = {}
  const finalParams = {}
  for (const param of params) {
    // This is workaround for gig params that are array example gigTypes[] , properties[]...
    // this way we are creating our own array , we can't use for example gigTypes[] as key because the key when we send params
    // will be gigTypes[][] and we don't want that
    const key = param[0]
    const value = param[1]
    const allowedToSendToRequest =
      urlAllowedParams.includes(key) && value !== '-1' && value !== ''
    if (allowedToSendToRequest) {
      if (key.includes('[')) {
        const actualKey = [...key].slice(0, key.length - 2).join('')
        finalParams[actualKey] = finalParams[actualKey]
          ? [...finalParams[actualKey], value]
          : [value]
      } else finalParams[key] = value
    }
  }
  return finalParams
  // getNow.forEach((value, key) => {
  //   const keyFormated = camelToSnake(key)
  //   const allowedToSendToRequest =
  //     urlAllowedParams.includes(key) && value !== '-1' && value !== ''
  //   if (allowedToSendToRequest) params[keyFormated] = value
  // })
  // return params
}

export const getShiftParametars = (hasMore = false, currentPage = 0) => {
  const location = localStorage.getItem('location')
  const params = getShiftsURLParams(history.location.search)
  // check location
  if (location) {
    const { longitude, latitude, regionId } = JSON.parse(location)
    if (regionId) {
      params.regions = [regionId]
    } else {
      params.longitude = longitude
      params.latitude = latitude
    }
  }
  if (params.distance) {
    params.distance_in = 'miles'
  }
  if (hasMore) {
    const nextPage = currentPage + 1
    params.page = nextPage
  }
  return params
}

export const getShiftParamsNoPage = () => {
  const location = localStorage.getItem('location')
  const params = getShiftsURLParams(history.location.search)
  // check location
  if (location) {
    const { longitude, latitude, regionId } = JSON.parse(location)
    if (regionId) {
      params.regions = [regionId]
    } else {
      params.longitude = longitude
      params.latitude = latitude
    }
  }
  if (params.distance) {
    params.distance_in = 'miles'
  }
  return params
}

export const fetchShiftsVirtualizationUpshifter = () => {
  const params = getShiftParamsNoPage()
  store.dispatch(getUpshifterShifts({ params, preventConcatenate: true }))
}

export const getRecommendedParams = urlParams => {
  const params = new URLSearchParams(urlParams)
  const finalParams = {}
  for (const param of params) {
    // This is workaround for gig params that are array example gigTypes[] , properties[]...
    // this way we are creating our own array , we can't use for example gigTypes[] as key because the key when we send params
    // will be gigTypes[][] and we don't want that
    const key = param[0]
    const value = param[1]
    if (key.includes('[')) {
      const actualKey = [...key].slice(0, key.length - 2).join('')
      finalParams[actualKey] = finalParams[actualKey]
        ? [...finalParams[actualKey], value]
        : [value]
    } else finalParams[key] = value
  }
  return finalParams
}

export const fetchRecommendedShiftsVirtualization = urlParams => {
  const params = getRecommendedParams(urlParams)
  dispatch(getUpshifterRecommendedShifts({ params, preventConcatenate: true }))
}

/**
 *
 * @param {*} name
 */
export const removeFromUrl = name => {
  const urlManager = new URLManager()
  urlManager.removeParamAndPush(name)
}

export const minutesDifferenceBetweenTwoDates = (dt2, dt1) => {
  const diff = dt2 - dt1
  return Math.floor(diff / 1000 / 60)
}

export const setLocationFromUserRegion = () => {
  let locationLocked
  const loggedInUser = AuthService.getLoggedInUser()
  const reduxLocations = store.getState().locations.data
  const reduxLocationsIsFetching = store.getState().locations.isFetching
  const reduxProperties = store.getState().properties.data
  const reduxPropertiesIsFetching = store.getState().properties.isFetching
  // Here we're checking if the user has a region assigned and also we're checking if the locations have finished fetching
  // So we don't get any race conditions while setting the users' location
  if (loggedInUser.regions && reduxLocations && !reduxLocationsIsFetching) {
    const userRegion = loggedInUser.regions[0]
    const region = reduxLocations.filter(
      location => location.id === userRegion.id,
    )
    const currentDate = new Date()
    locationLocked = {
      latitude: region[0].latitude,
      longitude: region[0].longitude,
      city: userRegion.name,
      status: true,
      userPickedLocation: true,
      timestamp: currentDate.getTime(),
    }
    localStorage.setItem('location', JSON.stringify(locationLocked))
    // Here we're checking if the properties have finished fetching
    // So we have data when setting the users' location
  } else if (reduxProperties.length && !reduxPropertiesIsFetching) {
    const region = reduxProperties[0]
    const currentDate = new Date()
    locationLocked = {
      latitude: region.latitude,
      longitude: region.longitude,
      city: region.name,
      status: true,
      userEnabled: true,
      userPickedLocation: true,
      timestamp: currentDate.getTime(),
    }
    localStorage.setItem('location', JSON.stringify(locationLocked))
  }
  return locationLocked
}

export const getUnsavedChangesMessage = pageName => {
  return `You will lose all changes made to the ${pageName}. You are trying to close without saving. Are you sure you want to leave the page?`
}

export const checkAndUpdateUserRegion = () => {
  const loggedInUser = AuthService.getLoggedInUser()
  store.dispatch(GetUserLocation(false))

  if (loggedInUser.regions) {
    return setLocationFromUserRegion()
  }
  return store
    .dispatch(
      getMyUser({
        include: [
          'google_calendar',
          'incomplete_workflows',
          'last_revoked_strike',
        ],
      }),
    )
    .then(() => setLocationFromUserRegion())
    .catch(error => {})
}

export async function getLocation() {
  // eslint-disable-next-line no-undef
  const { geolocation } = navigator
  return new Promise((resolve, reject) => {
    const currentDate = new Date()
    if (!geolocation) {
      const locationLocked = {
        latitude: null,
        longitude: null,
        userEnabled: false,
        status: false,
        userPickedLocation: false,
        timestamp: currentDate.getTime(),
      }
      resolve(locationLocked)
    }
    geolocation.getCurrentPosition(
      // This executes when user clicks Allow location
      position => {
        const { coords } = position
        const { latitude, longitude } = coords
        const locationLocked = {
          latitude,
          longitude,
          status: true,
          userEnabled: true,
          userPickedLocation: false,
          timestamp: currentDate.getTime(),
        }
        localStorage.setItem('location', JSON.stringify(locationLocked))
        resolve(locationLocked)
      },
      // This executes when user clicks Decline location
      () => {
        resolve(checkAndUpdateUserRegion())
      },
    )
  })
  // dispatch some kind of indicator that will trigger re-render in Regions.jsx
  // maybe a flag that will represent if the user allowed or blocked the option
}

/**
 * Checks if the location should be updated
 */
export const checkIfLocationShouldBeUpdated = () => {
  const location = localStorage.getItem('location')
  if (location && !location.userPickedLocation) {
    const { timestamp } = JSON.parse(location)
    const now = new Date()
    const minuteDifference = minutesDifferenceBetweenTwoDates(
      now.getTime(),
      timestamp,
    )
    return minuteDifference > LOCATION_CHECK_TTL
  }

  return true
}

/**
 * Checks if the user location should be updated
 */
export const localStorageTimerCheck = (localStorageItem, timerMinutes) => {
  const item = localStorage.getItem(localStorageItem)
  if (item) {
    const { timestamp } = JSON.parse(item)
    const now = new Date()
    const minuteDifference = minutesDifferenceBetweenTwoDates(
      now.getTime(),
      timestamp,
    )
    return minuteDifference > timerMinutes
  }
  return true
}

export const checkIfNotificationShouldBeUpdated = () => {
  const notification = localStorage.getItem('notification')
  if (notification) {
    const { timestamp } = JSON.parse(notification)
    const now = new Date()
    const minuteDifference = minutesDifferenceBetweenTwoDates(
      now.getTime(),
      timestamp,
    )
    return minuteDifference >= NOTIFICATION_CHECK_TTL
  }
  const currentDate = new Date()
  const notificationObject = {
    timestamp: currentDate.getTime(),
  }
  localStorage.setItem('notification', JSON.stringify(notificationObject))
  return true
}

export const updateUnreadNotifications = shouldBypassUpdate => {
  const shouldUpdate = checkIfNotificationShouldBeUpdated()
  if (shouldUpdate || shouldBypassUpdate) {
    const currentDate = new Date()
    const notificationObject = {
      timestamp: currentDate.getTime(),
    }
    localStorage.setItem('notification', JSON.stringify(notificationObject))
    store.dispatch(getUnreadNotifications({ preventConcatenate: true }))
  }
}

export const updateArray = (data, payload) => {
  const updatedArray = data.map(item => {
    if (item.id !== payload.id) {
      return item
    }
    return payload
  })
  return updatedArray
}

export const isObjectEmpty = arg => Object.entries(arg).length === 0

export const isMobile = () => window.innerWidth <= 576

export const isTablet = () => window.innerWidth <= 768

export const is2XS = () => window.innerWidth < 230

export const isXS = () => window.innerWidth >= 230 && window.innerWidth < 576

export const isSM = () => window.innerWidth >= 576 && window.innerWidth < 768

export const isMD = () => window.innerWidth >= 768 && window.innerWidth < 992

export const isLG = () => window.innerWidth >= 992 && window.innerWidth < 1024

export const isXL = () => window.innerWidth >= 1024 && window.innerWidth < 1300

export const is2XL = () => window.innerWidth >= 1300 && window.innerWidth < 1500

export const is3XL = () => window.innerWidth >= 1500 && window.innerWidth < 1700

export const is4XL = () => window.innerWidth >= 1700 && window.innerWidth < 1900

export const is5XL = () => window.innerWidth >= 1900
